// =====================      Dashboard action types START    =========================

export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST'
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS'
export const GET_PROJECT_FAIL = 'GET_PROJECT_FAIL'
export const CLEAR_GET_PROJECTS = 'CLEAR_GET_PROJECTS'

// PROJECT MEMBERS
export const GET_PROJECT_MEMBER_REQUEST = 'GET_PROJECT_MEMBER_REQUEST'
export const GET_PROJECT_MEMBER_SUCCESS = 'GET_PROJECT_MEMBER_SUCCESS'
export const GET_PROJECT_MEMBER_FAIL = 'GET_PROJECT_MEMBER_FAIL'
// PROJECT OBJECTIVE
export const PROJECT_OBJECTIVE_TYPES_REQUEST = 'PROJECT_OBJECTIVE_TYPES_REQUEST'
export const PROJECT_OBJECTIVE_TYPES_SUCCESS = 'PROJECT_OBJECTIVE_TYPES_SUCCESS'
export const PROJECT_OBJECTIVE_TYPES_FAIL = 'PROJECT_OBJECTIVE_TYPES_FAIL'
// PROJECT Audience
export const PROJECT_AUDIENCE_TYPES_REQUEST = 'PROJECT_AUDIENCE_TYPES_REQUEST'
export const PROJECT_AUDIENCE_TYPES_SUCCESS = 'PROJECT_AUDIENCE_TYPES_SUCCESS'
export const PROJECT_AUDIENCE_TYPES_FAIL = 'PROJECT_AUDIENCE_TYPES_FAIL'

// PROJECT Approvers
export const GET_PROJECT_APPROVERS_REQUEST = 'GET_PROJECT_APPROVERS_REQUEST'
export const GET_PROJECT_APPROVERS_SUCCESS = 'GET_PROJECT_APPROVERS_SUCCESS'
export const GET_PROJECT_APPROVERS_FAIL = 'GET_PROJECT_APPROVERS_FAIL'

// Project status

export const GET_PROJECT_STATUS_REQUEST = 'GET_PROJECT_STATUS_REQUEST'
export const GET_PROJECT_STATUS_SUCCESS = 'GET_PROJECT_STATUS_SUCCESS'
export const GET_PROJECT_STATUS_FAIL = 'GET_PROJECT_STATUS_FAIL'

// PROJECT EDIT
export const EDIT_PROJECT_REQUEST = 'EDIT_PROJECT_REQUEST'
export const EDIT_PROJECT_SUCCESS = 'EDIT_PROJECT_SUCCESS'
export const EDIT_PROJECT_FAIL = 'EDIT_PROJECT_FAIL'

// load FETCH_ALL
export const GET_FETCH_ALL_REQUEST = 'GET_FETCH_ALL_REQUEST'
export const GET_FETCH_ALL_SUCCESS = 'GET_FETCH_ALL_SUCCESS'
export const GET_FETCH_ALL_FAIL = 'GET_FETCH_ALL_FAIL'
export const CLEAR_GET_FETCH_ALLS = 'CLEAR_GET_FETCH_ALLS'


// create PROJECT

export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST'
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS'
export const CREATE_PROJECT_FAIL = 'CREATE_PROJECT_FAIL'
export const CLEAR_CREATE_PROJECT = 'CLEAR_CREATE_PROJECT'

// update project
export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST'
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS'
export const UPDATE_PROJECT_FAIL = 'UPDATE_PROJECT_FAIL'
export const UPDATE_PROJECT_RESET = 'UPDATE_PROJECT_RESET'

// project member invite link
export const RESEND_INVITE_MEMBER_REQUEST = 'RESEND_INVITE_MEMBER_REQUEST'
export const RESEND_INVITE_MEMBER_SUCCESS = 'RESEND_INVITE_MEMBER_SUCCESS'
export const RESEND_INVITE_MEMBER_FAIL = 'RESEND_INVITE_MEMBER_FAIL'
export const RESEND_INVITE_MEMBER_RESET = 'RESEND_INVITE_MEMBER_RESET'

// get CAMPAIGN

export const GET_CAMPAIGN_REQUEST = 'GET_CAMPAIGN_REQUEST'
export const GET_CAMPAIGN_SUCCESS = 'GET_CAMPAIGN_SUCCESS'
export const GET_CAMPAIGN_FAIL = 'GET_CAMPAIGN_FAIL'
export const CLEAR_GET_CAMPAIGN = 'CLEAR_GET_CAMPAIGN'


// =====================  Start PARTNER action types Start   =====================

export const LOAD_PARTNER_REQUEST = 'LOAD_PARTNER_REQUEST'
export const LOAD_PARTNER_SUCCESS = 'LOAD_PARTNER_SUCCESS'
export const LOAD_PARTNER_FAIL = 'LOAD_PARTNER_FAIL'
export const LOAD_PARTNER_RESET = 'LOAD_PARTNER_RESET'

// load PARTNER
export const GET_PARTNER_REQUEST = 'GET_PARTNER_REQUEST'
export const GET_PARTNER_SUCCESS = 'GET_PARTNER_SUCCESS'
export const GET_PARTNER_FAIL = 'GET_PARTNER_FAIL'
export const CLEAR_GET_PARTNERS = 'CLEAR_GET_PARTNERS'

// create PARTNER
export const CREATE_PARTNER_REQUEST = 'CREATE_PARTNER_REQUEST'
export const CREATE_PARTNER_SUCCESS = 'CREATE_PARTNER_SUCCESS'
export const CREATE_PARTNER_FAIL = 'CREATE_PARTNER_FAIL'
export const CLEAR_CREATE_PARTNER = 'CLEAR_CREATE_PARTNER'

// delete PARTNER
export const DELETE_PARTNER_REQUEST = 'DELETE_PARTNER_REQUEST'
export const DELETE_PARTNER_SUCCESS = 'DELETE_PARTNER_SUCCESS'
export const DELETE_PARTNER_FAIL = 'DELETE_PARTNER_FAIL'
export const DELETE_PARTNER_RESET = 'DELETE_PARTNER_RESET'



// get PROJECT SCHEDULE

export const GET_PROJECT_SCHEDULE_REQUEST = 'GET_PROJECT_SCHEDULE_REQUEST'
export const GET_PROJECT_SCHEDULE_SUCCESS = 'GET_PROJECT_SCHEDULE_SUCCESS'
export const GET_PROJECT_SCHEDULE_FAIL = 'GET_PROJECT_SCHEDULE_FAIL'
export const CLEAR_GET_PROJECT_SCHEDULE = 'CLEAR_GET_PROJECT_SCHEDULE'

// CHECK INVITATION EMAIL

export const CHECK_INVITATION_EMAIL_REQUEST = 'CHECK_INVITATION_EMAIL_REQUEST'
export const CHECK_INVITATION_EMAIL_SUCCESS = 'CHECK_INVITATION_EMAIL_SUCCESS'
export const CHECK_INVITATION_EMAIL_FAIL = 'CHECK_INVITATION_EMAIL_FAIL'
export const CLEAR_CHECK_INVITATION_EMAIL = 'CLEAR_CHECK_INVITATION_EMAIL'

// Project Timelins
export const GET_PROJECT_TIMELINES_REQUEST = 'GET_PROJECT_TIMELINES_REQUEST'
export const GET_PROJECT_TIMELINES_SUCCESS = 'GET_PROJECT_TIMELINES_SUCCESS'
export const GET_PROJECT_TIMELINES_FAIL = 'GET_PROJECT_TIMELINES_FAIL'
export const CLEAR_GET_PROJECT_TIMELINES = 'CLEAR_GET_PROJECT_TIMELINES'

// make payment partner
export const MAKE_PAYMENT_PARTNER_REQUEST = 'MAKE_PAYMENT_PARTNER_REQUEST'
export const MAKE_PAYMENT_PARTNER_SUCCESS = 'MAKE_PAYMENT_PARTNER_SUCCESS'
export const MAKE_PAYMENT_PARTNER_FAIL = 'MAKE_PAYMENT_PARTNER_FAIL'
export const CLEAR_MAKE_PAYMENT_PARTNER = 'CLEAR_MAKE_PAYMENT_PARTNER'

// Subscription plans
export const GET_SUBSCRIPTION_REQUEST = 'GET_SUBSCRIPTION_REQUEST'
export const GET_SUBSCRIPTION_SUCCESS = 'GET_SUBSCRIPTION_SUCCESS'
export const GET_SUBSCRIPTION_FAIL = 'GET_SUBSCRIPTION_FAIL'
export const GET_SUBSCRIPTION_RESET = 'GET_SUBSCRIPTION_RESET'

// project limition
export const GET_PROJECT_LIMIT_REQUEST = 'GET_PROJECT_LIMIT_REQUEST'
export const GET_PROJECT_LIMIT_SUCCESS = 'GET_PROJECT_LIMIT_SUCCESS'
export const GET_PROJECT_LIMIT_FAIL = 'GET_PROJECT_LIMIT_FAIL'
export const CLEAR_GET_PROJECT_LIMIT = 'CLEAR_GET_PROJECT_LIMIT'

// =====================  Start members action types Start   =========================

// load members
export const LOAD_MEMBER_REQUEST = 'LOAD_MEMBER_REQUEST'
export const LOAD_MEMBER_SUCCESS = 'LOAD_MEMBER_SUCCESS'
export const LOAD_MEMBER_FAIL = 'LOAD_MEMBER_FAIL'
export const LOAD_MEMBER_RESET = 'LOAD_MEMBER_RESET'

// GET members
export const GET_MEMBER_REQUEST = 'GET_MEMBER_REQUEST'
export const GET_MEMBER_SUCCESS = 'GET_MEMBER_SUCCESS'
export const GET_MEMBER_FAIL = 'GET_MEMBER_FAIL'
export const CLEAR_GET_MEMBERS = 'CLEAR_GET_MEMBERS'

// create members
export const CREATE_MEMBER_REQUEST = 'CREATE_MEMBER_REQUEST'
export const CREATE_MEMBER_SUCCESS = 'CREATE_MEMBER_SUCCESS'
export const CREATE_MEMBER_FAIL = 'CREATE_MEMBER_FAIL'
export const CLEAR_MEMBER = 'CLEAR_MEMBER'

// delete members
export const DELETE_MEMBER_REQUEST = 'DELETE_MEMBER_REQUEST'
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS'
export const DELETE_MEMBER_FAIL = 'DELETE_MEMBER_FAIL'
export const DELETE_MEMBER_RESET = 'DELETE_MEMBER_RESET'


// update members
export const UPDATE_MEMBER_REQUEST = 'UPDATE_MEMBER_REQUEST'
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS'
export const UPDATE_MEMBER_FAIL = 'UPDATE_MEMBER_FAIL'
export const UPDATE_MEMBER_RESET = 'UPDATE_MEMBER_RESET'

// =====================  End Members action types Start   =========================
// =====================  Start Job number  action types Start   =========================
// update members
export const CHECK_USER_BY_EMAIL_REQUEST = 'CHECK_USER_BY_EMAIL_REQUEST'
export const CHECK_USER_BY_EMAIL_SUCCESS = 'CHECK_USER_BY_EMAIL_SUCCESS'
export const CHECK_USER_BY_EMAIL_FAIL = 'CHECK_USER_BY_EMAIL_FAIL'
export const CHECK_USER_BY_EMAIL_RESET = 'CHECK_USER_BY_EMAIL_RESET'

// =====================  Start Project Background action types Start   =========================

// load client
export const LOAD_PROJECT_BACKGROUND_REQUEST = 'LOAD_PROJECT_BACKGROUND_REQUEST'
export const LOAD_PROJECT_BACKGROUND_SUCCESS = 'LOAD_PROJECT_BACKGROUND_SUCCESS'
export const LOAD_PROJECT_BACKGROUND_FAIL = 'LOAD_PROJECT_BACKGROUND_FAIL'
export const LOAD_PROJECT_BACKGROUND_RESET = 'LOAD_PROJECT_BACKGROUND_RESET'

// =====================  End  Project Background action types Start   =========================

// =====================  Start Project Objectives action types Start   =========================

// load objective
export const LOAD_PROJECT_OBJECTIVES_REQUEST = 'LOAD_PROJECT_OBJECTIVES_REQUEST'
export const LOAD_PROJECT_OBJECTIVES_SUCCESS = 'LOAD_PROJECT_OBJECTIVES_SUCCESS'
export const LOAD_PROJECT_OBJECTIVES_FAIL = 'LOAD_PROJECT_OBJECTIVES_FAIL'
export const LOAD_PROJECT_OBJECTIVES_RESET = 'LOAD_PROJECT_OBJECTIVES_RESET'

// =====================  End  Project Objectives action types Start   =========================

// =====================  Start Project Audiences action types Start   =========================

// load audience
export const LOAD_PROJECT_AUDIENCES_REQUEST = 'LOAD_PROJECT_AUDIENCES_REQUEST'
export const LOAD_PROJECT_AUDIENCES_SUCCESS = 'LOAD_PROJECT_AUDIENCES_SUCCESS'
export const LOAD_PROJECT_AUDIENCES_FAIL = 'LOAD_PROJECT_AUDIENCES_FAIL'
export const LOAD_PROJECT_AUDIENCES_RESET = 'LOAD_PROJECT_AUDIENCES_RESET'

// =====================  End  Project Audiences action types Start   =========================

// =====================  Start Project Timelines action types Start   =========================

// load Timelines
export const LOAD_PROJECT_TIMELINE_REQUEST = 'LOAD_PROJECT_TIMELINE_REQUEST'
export const LOAD_PROJECT_TIMELINE_SUCCESS = 'LOAD_PROJECT_TIMELINE_SUCCESS'
export const LOAD_PROJECT_TIMELINE_FAIL = 'LOAD_PROJECT_TIMELINE_FAIL'
export const LOAD_PROJECT_TIMELINE_RESET = 'LOAD_PROJECT_TIMELINE_RESET'

// create Timelines
export const CREATE_PROJECT_TIMELINE_REQUEST = 'CREATE_PROJECT_TIMELINE_REQUEST'
export const CREATE_PROJECT_TIMELINE_SUCCESS = 'CREATE_PROJECT_TIMELINE_SUCCESS'
export const CREATE_PROJECT_TIMELINE_FAIL = 'CREATE_PROJECT_TIMELINE_FAIL'
export const CLEAR_PROJECT_TIMELINE = 'CLEAR_PROJECT_TIMELINE'

// delete Timelines
export const DELETE_PROJECT_TIMELINE_REQUEST = 'DELETE_PROJECT_TIMELINE_REQUEST'
export const DELETE_PROJECT_TIMELINE_SUCCESS = 'DELETE_PROJECT_TIMELINE_SUCCESS'
export const DELETE_PROJECT_TIMELINE_FAIL = 'DELETE_PROJECT_TIMELINE_FAIL'
export const DELETE_PROJECT_TIMELINE_RESET = 'DELETE_PROJECT_TIMELINE_RESET'


// update Timelines
export const UPDATE_PROJECT_TIMELINE_REQUEST = 'UPDATE_PROJECT_TIMELINE_REQUEST'
export const UPDATE_PROJECT_TIMELINE_SUCCESS = 'UPDATE_PROJECT_TIMELINE_SUCCESS'
export const UPDATE_PROJECT_TIMELINE_FAIL = 'UPDATE_PROJECT_TIMELINE_FAIL'
export const UPDATE_PROJECT_TIMELINE_RESET = 'UPDATE_PROJECT_TIMELINE_RESET'

// update Timelines
export const GET_TIMELINE_STAGE_REQUEST = 'GET_TIMELINE_STAGE_REQUEST'
export const GET_TIMELINE_STAGE_SUCCESS = 'GET_TIMELINE_STAGE_SUCCESS'
export const GET_TIMELINE_STAGE_FAIL = 'GET_TIMELINE_STAGE_FAIL'
export const GET_TIMELINE_STAGE_RESET = 'GET_TIMELINE_STAGE_RESET'

// update Timelines
export const UPLOADE_TIMELINE_STAGE_DOCUMENT_REQUEST = 'UPLOADE_TIMELINE_STAGE_DOCUMENT_REQUEST'
export const UPLOADE_TIMELINE_STAGE_DOCUMENT_SUCCESS = 'UPLOADE_TIMELINE_STAGE_DOCUMENT_SUCCESS'
export const UPLOADE_TIMELINE_STAGE_DOCUMENT_FAIL = 'UPLOADE_TIMELINE_STAGE_DOCUMENT_FAIL'
export const UPLOADE_TIMELINE_STAGE_DOCUMENT_RESET = 'UPLOADE_TIMELINE_STAGE_DOCUMENT_RESET'

// =====================  End  Project Timelines action types Start   =========================


// =====================  Start Project Audiences action types Start   =========================

// load audience
export const LOAD_PROJECT_SUPPORTING_DOCS_REQUEST = 'LOAD_PROJECT_SUPPORTING_DOCS_REQUEST'
export const LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS = 'LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS'
export const LOAD_PROJECT_SUPPORTING_DOCS_FAIL = 'LOAD_PROJECT_SUPPORTING_DOCS_FAIL'
export const LOAD_PROJECT_SUPPORTING_DOCS_RESET = 'LOAD_PROJECT_SUPPORTING_DOCS_RESET'

// Project supporting document
export const GET_PROJECT_SUPPORTING_DOCS_REQUEST = 'GET_PROJECT_SUPPORTING_DOCS_REQUEST'
export const GET_PROJECT_SUPPORTING_DOCS_SUCCESS = 'GET_PROJECT_SUPPORTING_DOCS_SUCCESS'
export const GET_PROJECT_SUPPORTING_DOCS_FAIL = 'GET_PROJECT_SUPPORTING_DOCS_FAIL'
export const CLEAR_GET_PROJECT_SUPPORTING_DOCS = 'CLEAR_GET_PROJECT_SUPPORTING_DOCS'

// =====================  End  Project Audiences action types Start   =========================

// load chats
export const GET_CHAT_SUCCESS = 'GET_CHAT_SUCCESS'
export const GET_CHAT_FAIL = 'GET_CHAT_FAIL'
export const GET_CHAT_REQUEST = 'GET_CHAT_REQUEST'

// send chats
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL'
export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'

// chats users
export const GET_CHAT_USERS_SUCCESS = 'GET_CHAT_USERS_SUCCESS'
export const GET_CHAT_USERS_FAIL = 'GET_CHAT_USERS_FAIL'
export const GET_CHAT_USERS_REQUEST = 'GET_CHAT_USERS_REQUEST'


